module.exports = __webpack_public_path__ + "img/login_img.bff9a7c4.png";